import { CLP } from "@/common/schema/claims-process";
import { defaultCommandValidator } from "../../_common/validators";
import { ARE_EQUAL } from "@/fx/data-helpers";
import { CLM } from "@/common/schema/claims";

export function defaultClaimValidator<TCommand, TContext>(command: TCommand, ctx: TContext): boolean {
  return defaultCommandValidator(command, (ctx as any).data.claim);
}

export function statusClaimValidator<TCommand, TContext>(command: TCommand, ctx: TContext, expectedStatus: CLP.BbcStatus): boolean {
  const claim = (ctx as any).data.claim;

  return claim.bbcStatus === expectedStatus;
}

export function actionClaimValidator<TCommand, TContext>(command: TCommand, ctx: TContext, expectedAction: CLP.Action): boolean {
  const claim = (ctx as any).data.claim;
  return claim.baseline_action === expectedAction;
}

export function ulcaClaimValidator<TCommand, TContext>(command: TCommand, ctx: TContext): boolean {
  const ulcas = (ctx as any).data.ulcas;
  const claimApprover_level = (command as any).claimApprover_level;

  return ulcas !== undefined && ulcas.length > 0 && claimApprover_level === ulcas[ulcas.length - 1].claimApprover_level;
}

export function issueClaimValidator<TCommand, TContext>(command: TCommand, ctx: TContext): boolean {
  const issues = (ctx as any).data.issues;
  const issue = issues !== undefined && issues.length > 0 ? issues[issues.length - 1] : undefined;
  const command_ = command as any;

  return issues !== undefined && issue !== undefined
                              && ARE_EQUAL.text    (command_.issueType.identifier,  issue.issueType.identifier )
                              && ARE_EQUAL.text    (command_.assignedTo.identifier, issue.assignedTo.identifier)
                              && ARE_EQUAL.text    (command_.description,           issue.description          )
                              && ARE_EQUAL.text    (command_.issueResolutionNotes,  issue.issueResolutionNotes );
}

export function productLineItemClaimValidator<TCommand, TContext>(command: TCommand, ctx: TContext): boolean {
  const claim = (ctx as any).data.claim;
  const productLineItems = (ctx as any).data.productLineItems;
  const command_ = command as any;

  return ARE_EQUAL.int (command_.casesRequested,   claim.casesRequested  )
      && ARE_EQUAL.int (command_.retailPercentage, claim.retailPercentage)
      && ARE_EQUAL.text(command_.distributorNotes, claim.distributorNotes)
      && command_.existingProductLineItems?.map((existingProductLineItem: CLM.RawProductLineItem) => {
          return productLineItems.some((pli: CLM.ProductLineItem) => pli.id?.asInt?.toString() === existingProductLineItem.id                &&
                                                                     pli.productId?.asInt?.toString() === existingProductLineItem.productId  &&
                                                                     pli.reason.identifier   === existingProductLineItem.reason              &&
                                                                     pli.quantity            === existingProductLineItem.quantity            &&
                                                                     pli.creditPercentage    === existingProductLineItem.creditPercentage      );
      });
}

export function productValidator<TCommand, TContext>(command: TCommand, ctx: TContext): boolean {
  const product = (ctx as any).data.product;
  const command_ = command as any;

  return product !== undefined
      && ARE_EQUAL.text    (command_.brandFamily,                   product.brandFamily                  )
      && ARE_EQUAL.text    (command_.brandStyle,                    product.brandStyle                   )
      && ARE_EQUAL.text    (command_.beverageType.identifier,       product.beverageType.identifier      )
      && ARE_EQUAL.text    (command_.packaging_container.identifier,product.packaging_container.identifier)

      && ARE_EQUAL.text    (command_.packaging_type,                product.packaging_type               )
      && ARE_EQUAL.text    (command_.sku6,                          product.sku6                         )
      && ARE_EQUAL.text    (command_.data,                          product.data                         )
      && command_.packaging_skinny              === product.packaging_skinny
      && command_.packaging_airline             === product.packaging_airline
      && command_.packaging_single              === product.packaging_single
      && command_.packaging_ptep                === product.packaging_ptep
      && command_.flaggedBySapDeletionIndicator === product.flaggedBySapDeletionIndicator
      && command_.featured                      === product.featured
      && command_.archived                      === product.archived;
}
